import { render, staticRenderFns } from "./InventoryReportComponent.vue?vue&type=template&id=2e0b0dde&"
import script from "./InventoryReportComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports